import SameSiteCheckCore from './samesite-check';

type reason = 'sameSite' | 'manualCaused' | 'other';

export default class ReasonCore {
	// 默认原因
	private static readonly DEFAULT_REASON: reason = 'other';
	/**
	 * 获取原因
	 * @param urlStackInfo url 堆栈信息
	 */
	static getReason (urlStackInfo: Record<string, any>[]): reason {
		if (SameSiteCheckCore.check(urlStackInfo)) return 'sameSite';
		if (this.checkIsManualCaused(urlStackInfo)) return 'manualCaused';
		return this.DEFAULT_REASON;
	}
	/**
	 * 校验是否为人工切换页面触发，校验规则：
	 * 获取 url 堆栈信息中各 url hash 部分，去重后先判断数量：
	 * 若 hash 数量 > 2，则认为是人工触发，若 hash 数量 < 2，则认为不是人工触发，若 hash 数量 = 2，
	 * 判断 hash 是否为有规律的重复：a、b、a、b、……，有规则则认为不是人工触发，否则认为是
	 * @param urlStackInfo
	 */
	static checkIsManualCaused (urlStackInfo: Record<string, any>[]): boolean {
		const hashStackInfo: string[] = urlStackInfo.map((item: Record<string, any>): string => {
			if (!item || !item.url) return '';
			let hash: string = item.url.split('#')[1];
			if (!hash) return '';
			return hash.split('?')[0];
		});
		let hashCount: number = new Set(hashStackInfo).size;

		if (hashCount > 2) return true;
		if (hashCount < 2) return false;
		let isRegularHash: boolean = true;
		let evenHash: string = hashStackInfo[0];
		let oddHash: string = hashStackInfo[1];
		hashStackInfo.forEach((hash: string, index: number): void => {
			if (index < 2) return;
			if (index % 2 === 0 && hash !== evenHash) isRegularHash = false;
			if (index % 2 === 1 && hash !== oddHash) isRegularHash = false;
		});
		return !isRegularHash;
	}
}
